
export enum PageTypeEnum {
    Loading,
    CountDown,
    CountHAStateWide,
    CountHADistrict,
    CountLCStateWide,
    LGEResults
}